export default "__VITE_ASSET__CWB5sDL9__"